import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BannerSlider } from "../Slider/Slider/Slider";
import { News } from "../../../../types/newsAPI";
import { Banners } from "../../../../types/newsAPI";

interface MainPageBannerProps{
  banery: Banners[];
  loading: boolean;
}

export const MainPageBanner = (props: MainPageBannerProps) => {
  const {banery, loading} = props

  return (
    <section aria-label="Main Page News Banner">
      <BannerSlider banery={banery} loading={loading}/>
    </section>
  );
};
